export default {
    keys: {
        id: 'id',
        date: 'filterDate',
        age: 'minimumAge.id',
        daypart: 'dayPart.id',
        start: 'start',
        end: 'end',
        exhibitionId: 'Tentoonstellingen',
        movieId: 'Films',
        activityId: 'Activiteit',
        lectureId: 'Lezingen',
    },
    operators: {
        in: 'In',
        equals: 'Eq',
        lowerThan: 'Lt',
        greaterThan: 'Gt'
    },
    inputTypes: {
        checkboxes: 'checkboxes',
        dropdown: 'dropdown'
    },
    queryParams: {
        page: 'page',
        text: 'text'
    },
    magicStrings: {
        queryCount: '{{queryCount}}',
        totalCount: '{{totalCount}}'
    },
    culture: {
        dutch: 'nl-NL',
        english: 'en-GB'
    }
}